import { NavLink, Outlet } from "react-router";
import { cn } from "@/lib/utils";

const SETTINGS_NAV = [
  { label: "Profile", path: "/settings/profile", icon: "👤" },
  { label: "Security", path: "/settings/security", icon: "🛡️" },
  { label: "Team", path: "/settings/team", icon: "👥" },
  { label: "Billing", path: "/settings/billing", icon: "💳" },
  { label: "Feedback", path: "/settings/feedback", icon: "💬" },
  { label: "E-commerce", path: "/settings/ecommerce", icon: "🛍️" },
  { label: "API Keys", path: "/settings/api-keys", icon: "🔑" },
  { label: "Notifications", path: "/settings/notifications", icon: "🔔" },
  { label: "Integrations", path: "/settings/integrations", icon: "🔗" },
  { label: "Marketplace", path: "/settings/marketplace", icon: "🏪" },
  { label: "Domains", path: "/settings/domains", icon: "🌐" },
  { label: "Domain Setup", path: "/settings/domain-purchase", icon: "🛒" },
  { label: "DNS", path: "/settings/domain-dns", icon: "📡" },
  { label: "Webhooks", path: "/settings/webhooks", icon: "🔗" },
  { label: "Collaborations", path: "/settings/collaborations", icon: "🤝" },
  { label: "Audit Log", path: "/settings/audit-log", icon: "📜" },
  { label: "Lead Scoring", path: "/settings/scoring", icon: "📊" },
  { label: "Custom Fields", path: "/settings/custom-fields", icon: "🧩" },
  { label: "Booking Embed", path: "/settings/bookings/embed", icon: "🗓️" },
  { label: "Calendar Sync", path: "/settings/calendar", icon: "📆" },
  { label: "Inbox Routing", path: "/settings/messaging/routing", icon: "🧭" },
];

export default function SettingsLayout() {
  return (
    <div>
      <h1 className="text-2xl font-bold text-foreground">Settings</h1>
      <p className="mt-1 text-muted-foreground">Manage your account and preferences</p>

      <div className="mt-6 flex flex-col gap-6 md:flex-row">
        {/* Settings sidebar tabs */}
        <nav className="w-full shrink-0 md:w-48">
          <ul className="flex gap-1 overflow-x-auto md:flex-col">
            {SETTINGS_NAV.map((item) => (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    cn(
                      "flex items-center gap-2 whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors",
                      isActive
                        ? "bg-accent text-accent-foreground"
                        : "text-muted-foreground hover:bg-accent/50 hover:text-foreground",
                    )
                  }
                >
                  <span>{item.icon}</span>
                  <span>{item.label}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        {/* Settings content */}
        <div className="flex-1">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
